import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import AboutDR from './AboutDr'
import Achievements from './Achivements'
import Awards from './Awards'
import Breadcrumb from './Breadcrum'
import ContactInfo from './contactAbout'
import WhatWeDo from './WhatWeDo'
import FAQ from './Faq'
import NumCounter from '../../NumCounter'

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Dr. (Major) Rajesh Bhardwaj | Senior ENT Specialist in Delhi</title>
            <meta name="description" content="About Dr. (Major) Rajesh Bhardwaj, senior ENT specialist in Delhi with 35+ years’ experience, ex-Army doctor, and expert in advanced ENT surgeries." />
            <meta name="keywords" content="ENT doctor Delhi, best ENT specialist, about ENT surgeon, experienced ENT in Delhi" />
            <link rel="canonical" href="https://entdelhi.com/about-doctor-rajesh-bhardwaj/" />
            <meta property="og:title" content="Dr. (Major) Rajesh Bhardwaj | Senior ENT Specialist in Delhi" />
            <meta property="og:description" content="About Dr. (Major) Rajesh Bhardwaj, senior ENT specialist in Delhi with 35+ years’ experience, ex-Army doctor, and expert in advanced ENT surgeries." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
<main>
        <Breadcrumb/>
        <AboutDR />
        <NumCounter />
        <Achievements />
        <WhatWeDo />
        <Awards/>
        <FAQ/>        
        <ContactInfo />
      </main>
    </div>
  )
}

